import { snowplowButtonClick } from '@analytics/snowplow/events';
import Icon from '@components/icons';
import TeamTabs from '@screens/lp-default/components/team/components/tabs';
import * as Styles from '@screens/lp-default/components/team/styles';

type Props = {
  id: string;
};

const handleIntroButtonClick = () => {
  snowplowButtonClick('want_know', '/planos', '/diretrizes-editoriais/', 'content_section');
  window.location.href = '/diretrizes-editoriais/';
};

export default function Team({ id }: Props) {
  return (
    <Styles.Container id={id} data-testid="team">
      <Styles.Intro>
        <Styles.IntroTitle>Equipe de conteúdo</Styles.IntroTitle>
        <Styles.IntroSubTitle>
          Conheça os especialistas e o processo por trás da mais completa e confiável solução digital para a prática
          médica no Brasil!
        </Styles.IntroSubTitle>
        <Styles.IntroDescription>
          Entre conteudistas, editores médicos e profissionais de edição, um conteúdo passa por pelo menos 5
          especialistas até chegar a você.
        </Styles.IntroDescription>
        <Styles.IntroButton onClick={handleIntroButtonClick}>
          Saiba mais <Icon icon="arrow-square-out" size={20} />
        </Styles.IntroButton>
      </Styles.Intro>
      <TeamTabs />
    </Styles.Container>
  );
}
